"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rolEchainsMock = void 0;
const rolEchain_mock_1 = require("./rolEchain.mock");
exports.rolEchainsMock = [rolEchain_mock_1.rolEchainWithAdapterLink2828RMock];
//# sourceMappingURL=rolEchains.mock.js.map